import React, { Component } from 'react';
import axios from 'axios';
import { LoadingButton } from '../common/LoadingButton';

export class VoteSubmitted extends Component {
    state = {
        isEmailReceiptSending: false,
        isEmailReceiptSent: false,
        smsNumber: null,
        isShowSms: false,
        emailRecipients: null
    }

    handlePrint = () => {
        window.print();
    }

    handleShowSms = () => {
        this.setState({ isShowSms: true })
    }

    handleSendSms = () => {
        if (!window.confirm("Are you sure you want to send an SMS to " + this.state.smsNumber + "?")) {
            return;
        }

        this.setState({ isSmsReceiptSending: true })
        axios.post('/vote/smsRcpt', {
            id: this.props.voter.uniqueId,
            key: this.props.voter.guid,
            ballotId: this.props.ballot.id,
            phoneNumber: this.state.smsNumber
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    this.setState({ isSmsReceiptSent: true })
                }
                else {
                    this.props.onVoteError(response.data.errorMessage);
                }

                this.setState({ isSmsReceiptSending: false })
            })
            .catch(function (error) {
                alert(error)
            })
    }

    handleSendEmail = () => {
        if (!window.confirm("Are you sure you want to send an email to your registered voter email address?")) {
            return;
        }

        this.setState({ isEmailReceiptSending: true })
        axios.post('/vote/emailRcpt', {
            id: this.props.voter.uniqueId,
            key: this.props.voter.guid,
            ballotId: this.props.ballot.id
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    this.setState({ emailRecipients: response.data.payload.join(" and ") })
                    this.setState({ isEmailReceiptSent: true })
                }
                else {
                    this.props.onVoteError(response.data.errorMessage);
                }

                this.setState({ isEmailReceiptSending: false })
            })
            .catch(function (error) {
                alert(error)
            })
    }

    handleSmsChange = (event) => {
        this.setState({ smsNumber: event.target.value })
    }

    render() {
        return (
            <React.Fragment>
                {(!this.props.ballot.isVoteChange || this.props.isJustSubmitted) &&
                    < div className="p-2 rounded-lg shadow-lg bg-green-700 block w-full text-white font-medium text-center mb-4 sticky top-2">
                        {this.props.isJustSubmitted &&
                            <React.Fragment>
                                <p className="font-medium text-xl mb-2">Vote successfully cast!</p>
                                {this.props.ballot.isReceiptConfirmation &&
                                    <div>
                                        <div>
                                            <p>Your receipt number is:</p>
                                            <p className="text-3xl font-bold my-2">{this.props.groupVote.receipt}</p>
                                            <p>Please take a copy of this receipt if you wish to confirm your submission at a later date.</p>
                                        </div>
                                        <div className="my-4">
                                            <button className="btn mr-2" onClick={this.handlePrint}>Print Receipt</button>
                                            {this.props.ballot.isSmsReceipt && !this.state.isSmsReceiptSent &&
                                                <button className="btn mr-2" onClick={this.handleShowSms}>SMS Receipt</button>
                                            }
                                            <LoadingButton className="btn"
                                                onBtnClick={this.handleSendEmail}
                                                btnText="Email Receipt"
                                                isLoading={this.state.isEmailReceiptSending} />
                                        </div>
                                    </div>
                                }
                                {this.state.isShowSms && !this.state.isSmsReceiptSent &&
                                    <div>
                                        <input type="text" placeholder="SMS number"
                                            className="text-gray-600 inline-block mr-2 w-64"
                                            onChange={this.handleSmsChange} />
                                        <LoadingButton className="btn mr-2"
                                            onBtnClick={this.handleSendSms}
                                            btnText="Send SMS"
                                            isLoading={this.state.isSmsReceiptSending} />
                                    </div>
                                }
                                {this.state.isSmsReceiptSent && <p>SMS sent to {this.state.smsNumber}</p>}
                                {this.state.isEmailReceiptSent && this.state.emailRecipients && <p>Email sent to {this.state.emailRecipients}</p>}
                            </React.Fragment>
                        }
                        {this.props.groupVote && this.props.groupVote.voteDate && <p>Vote submitted: {this.props.groupVote.voteDate}</p>}
                    </div >
                }
                {this.props.ballot.isVoteChange &&
                    <div className="p-2 rounded-lg shadow-lg bg-amber-400 block w-full text-white font-medium text-center mb-4 sticky top-2">
                        {!this.props.isJustSubmitted &&
                            <p className="mb-4">Vote was previously submitted {this.props.groupVote.voteDate}.</p>
                        }
                        <p>To change your vote please update your selection(s) and Submit.</p>
                    </div>
                }
            </React.Fragment>
        );
    }
}